// src/utils/config.js
const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL,
    frontendUrl: process.env.REACT_APP_FRONTEND_URL
  },
  env: process.env.REACT_APP_ENV || 'development'
};

export default config;
